import React from "react";

import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";

import { sendReport } from "actions/offline";

import { ZoomyDialog } from "components/MaterialDialog";

import { closeAllHashModals, returnToLocation } from "lib/navigation";

import { getCurrentSale } from "selectors";

import EmailForm from "./EmailForm";

const initialValues = {
  rawEmailAddress: "",
  businessUserIds: [],
  emailRecipients: [],
};

const validationSchema = Yup.object({
  rawEmailAddress: Yup.string().email("Please enter a valid email address"),
  businessUserIds: Yup.array(),
  emailRecipients: Yup.array(),
  emailPresent: Yup.array().when(
    ["rawEmailAddress", "emailRecipients", "businessUserIds"],
    (rawEmailAddress, emailRecipients, businessUserIds, schema) => {
      return schema.test({
        test: () =>
          rawEmailAddress ||
          emailRecipients.length > 0 ||
          businessUserIds.length > 0,
        message: "Select at least one email recipient",
      });
    },
  ),
});

const EmailReportModal = ({
  reportUrl,
  businessId,
  reportName,
  deploymentId,
  returnTo,
}) => {
  const dispatch = useDispatch();
  const currentSale = useSelector(getCurrentSale);
  const onClose = () => {
    if (returnTo) {
      returnToLocation(returnTo);
    } else {
      closeAllHashModals();
    }
  };

  const handleSubmit = values => {
    const { emailRecipients, businessUserIds, rawEmailAddress } = values;
    dispatch(
      sendReport(
        currentSale,
        reportUrl,
        reportName,
        emailRecipients,
        businessUserIds,
        rawEmailAddress,
        businessId,
        deploymentId,
      ),
    );

    onClose();
  };

  return (
    <ZoomyDialog open onClose={onClose} scroll="paper" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <EmailForm
          onClose={onClose}
          reportName={reportName}
          businessId={businessId}
          deploymentId={deploymentId}
        />
      </Formik>
    </ZoomyDialog>
  );
};

export default EmailReportModal;
